import React, { useState, useEffect } from 'react';
import { useIntl } from 'umi';
import classnames from 'classnames';
import { SelectMultiple } from 'tea-component';
import { checkDateRangeDiff, isSameArrayValue } from '../../utils';

export default function YearSelect(props: any) {
  const { years = [], value: valueOuter, onChange, className } = props;

  const { formatMessage } = useIntl();

  const [value, setValue] = useState<string[]>([]);
  useEffect(() => {
    const valueTmp = Array.isArray(valueOuter) ? valueOuter : [];
    setValue(valueTmp);
  }, [valueOuter]);

  const options = years?.map((year: any) => ({ text: year, value: year })) || [];

  // 获取展示文本
  const getShowEmben = (opt) => {
    const len = opt.length;
    const [first] = opt;
    if (!len) return '';
    if (len === 1) return first?.value;
    if (len > 2) return len;
    // 因为可能存在很多年份，要保持年份顺序，需要先排序再展示
    const sortedArr = opt.sort((a, b) => Number(a?.value) - Number(b?.value));
    return sortedArr.reduce((x: any, y: any) => `${x.value},${y.value}`);
  };

  const sortValue = (_value) => {
    const len = _value.length;
    if (!len) return _value;
    if (len > 1) return _value.sort((a, b) => Number(a) - Number(b));
    return _value;
  };

  return (
    <SelectMultiple
      className={classnames('select-item dbi-top-genre-market-select', className)}
      overlayClassName="dbi-top-genre-market-select-overlay"
      staging={false}
      size="m"
      matchButtonWidth
      appearance="button"
      options={options}
      button={(option) => (
        <div className="select-button">
          <div className="select-button-text">{formatMessage({ id: 'dbi_global_view_year' })}</div>
          <div className="dbi-select-flex">{getShowEmben(option)}</div>
        </div>
      )}
      value={value}
      onChange={(value) => {
        const valueTmp = sortValue(value);
        if (valueTmp?.length >= 2) {
          const startDate = valueTmp?.[0] ? `${valueTmp?.[0]}-01-01` : '';
          const endDate = valueTmp?.[valueTmp.length - 1] ? `${valueTmp?.[valueTmp.length - 1]}-01-01` : '';
          const isValidRange = checkDateRangeDiff(startDate, endDate);
          if (!isValidRange) return;
        }
        setValue(sortValue(value));
      }}
      onClose={() => {
        if (isSameArrayValue(valueOuter, value)) return;
        if (value?.length) {
          onChange?.(value);
          return;
        }
        const valueTmp = years?.slice(years?.length - 2)?.filter((year: any) => year);
        setValue(valueTmp);
        onChange?.(valueTmp);
      }}
    />
  );
}
